export default "__VITE_ASSET__DJ08TQJj__"